import React, { useState } from "react";
import GanttTimelineHeader from "./components/GanttTimelineHeader";
import GanttGrid from "./components/GanttGrid";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";

/*
  DEMO DATA
  =========
  Projects with child moves.
  Dates deliberately staggered to show overlaps, gaps, and realism.
*/

export default function ProjectGantt() {
	
	var [ganttMode, setGanttMode] = useState("OVERLAY");

	var projects = [
	  {
	    id: 1,
	    name: "HQ Consolidation",
	    status: "At Risk",

	    plannedStart: new Date("2025-01-06"),
	    plannedEnd: new Date("2025-06-30"),

	    actualStart: new Date("2025-01-20"),      // late start
	    actualEnd: null,                           // still running

	    moves: [
	      {
	        id: 101,
	        label: "MOVE-001 – Finance → Operations",
	        status: "In Progress",

	        plannedStart: new Date("2025-02-03"),
	        plannedEnd: new Date("2025-03-15"),

	        actualStart: new Date("2025-02-10"),   // slipped
	        actualEnd: null
	      },
	      {
	        id: 102,
	        label: "MOVE-002 – HR → People Ops",
	        status: "Planned",

	        plannedStart: new Date("2025-03-18"),
	        plannedEnd: new Date("2025-04-12"),

	        actualStart: null,
	        actualEnd: null
	      },
	      {
	        id: 103,
	        label: "MOVE-003 – IT → Engineering",
	        status: "Planned",

	        plannedStart: new Date("2025-04-20"),
	        plannedEnd: new Date("2025-05-22"),

	        actualStart: null,
	        actualEnd: null
	      }
	    ]
	  },

	  {
	    id: 2,
	    name: "Regional Office Refresh",
	    status: "On Track",

	    plannedStart: new Date("2025-01-20"),
	    plannedEnd: new Date("2025-04-30"),

	    actualStart: new Date("2025-01-18"),      // early start
	    actualEnd: new Date("2025-04-22"),        // finished early

	    moves: [
	      {
	        id: 201,
	        label: "MOVE-004 – Sales → West Wing",
	        status: "Complete",

	        plannedStart: new Date("2025-01-22"),
	        plannedEnd: new Date("2025-02-10"),

	        actualStart: new Date("2025-01-21"),
	        actualEnd: new Date("2025-02-05")      // early finish
	      },
	      {
	        id: 202,
	        label: "MOVE-005 – Marketing → Level 3",
	        status: "In Progress",

	        plannedStart: new Date("2025-02-18"),
	        plannedEnd: new Date("2025-03-28"),

	        actualStart: new Date("2025-02-20"),
	        actualEnd: null
	      }
	    ]
	  },

	  {
	    id: 3,
	    name: "Warehouse Optimisation",
	    status: "Planned",

	    plannedStart: new Date("2025-03-01"),
	    plannedEnd: new Date("2025-08-15"),

	    actualStart: new Date("2025-03-01"),
	    actualEnd: new Date("2025-09-15"),

	    moves: [
	      {
	        id: 301,
	        label: "MOVE-006 – Storage Re-layout",
	        status: "Planned",

	        plannedStart: new Date("2025-04-01"),
	        plannedEnd: new Date("2025-05-15"),

	        actualStart: null,
	        actualEnd: null
	      }
	    ]
	  }
	];


  /*
    TIMELINE CONFIG
    ===============
    One place to control the scale.
  */

  var timelineStart = new Date("2025-01-01");
  var timelineEnd   = new Date("2025-08-31");

  var weekWidth = 40;   // px per week
  var rowHeight = 42;   // px per row

  function handleMoveClick(move) {
    console.log("Navigate to move:", move);
    // later:
    // navigate(`/moves/${move.id}`)
  }

  return (
    <div style={{ padding: "0px", marginLeft:'60px', marginTop:'80px', width:'calc(100% - 60px)'}}>
	<Header />
	 <LeftMenu />

      {/* HEADER */}
	  <div style={styles.header}>
		  <div style={styles.headerRow}>
	
		    {/* LEFT */}
		    <div>
		      <div style={styles.title}>Programme Gantt</div>
		      <div style={styles.subtitle}>Projects and Moves Overview</div>
		    </div>
	
		    {/* RIGHT – MODE TOGGLE */}
		    <div style={styles.modeToggle}>
	
		      <button
		        onClick={() => setGanttMode("PLANNED")}
		        style={ganttMode === "PLANNED" ? styles.modeActive : styles.modeInactive}
		      >
		        Planned
		      </button>
	
		      <button
		        onClick={() => setGanttMode("ACTUAL")}
		        style={ganttMode === "ACTUAL" ? styles.modeActive : styles.modeInactive}
		      >
		        Actual
		      </button>
	
		      <button
		        onClick={() => setGanttMode("OVERLAY")}
		        style={ganttMode === "OVERLAY" ? styles.modeActive : styles.modeInactive}
		      >
		        Overlay
		      </button>
	
		    </div>
	
		  </div>
	</div>

      {/* TIMELINE HEADER */}
      <div style={styles.timelineHeader}>
        <div style={styles.labelSpacer} />
        <div style={styles.timelineScroll}>
          <GanttTimelineHeader
            startDate={timelineStart}
            endDate={timelineEnd}
            weekWidth={weekWidth}
          />
        </div>
      </div>

      {/* GRID */}
      <div style={styles.grid}>
        <GanttGrid
          projects={projects}
          timelineStart={timelineStart}
          weekWidth={weekWidth}
          rowHeight={rowHeight}
          onMoveClick={handleMoveClick}
		  ganttMode={ganttMode}
        />
      </div>

    </div>
  );
}

const styles = {

  /* ===============================
     PAGE / FRAME
     =============================== */

  page: {
    width: "100%",
    height: "100%",
    backgroundColor:'#eceff3',
    overflow: "hidden"
  },

  /* ===============================
     HEADER
     =============================== */

  header: {
    padding: "16px 24px",
	backgroundColor:'#eceff3',
    //background: "linear-gradient(180deg, #FFFFFF 0%, #F3F5F8 100%)",
    //borderBottom: "1px solid rgba(0,0,0,0.08)",
    //boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
  },

  title: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#222"
  },

  subtitle: {
    fontSize: "13px",
    color: "#666",
    marginTop: "4px"
  },

  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "12px"
  },

  /* ===============================
     MODE TOGGLE
     =============================== */

  modeToggle: {
    display: "flex",
    gap: "8px"
  },

  modeActive: {
    padding: "6px 16px",
    borderRadius: "20px",
    border: "none",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
    color: "#ffffff",
    background: "linear-gradient(180deg, #4285F4 0%, #1E58B6 100%)",
    boxShadow: "0 3px 6px rgba(30,88,182,0.35)"
  },

  modeInactive: {
    padding: "6px 16px",
    borderRadius: "20px",
    border: "1px solid rgba(0,0,0,0.15)",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 500,
    color: "#444",
    background: "linear-gradient(180deg, #FFFFFF 0%, #F2F4F7 100%)"
  },

  /* ===============================
     TIMELINE HEADER
     =============================== */

  timelineHeader: {
    display: "flex",
    background: "linear-gradient(180deg, #2F6FD6 0%, #1F56B8 100%)",
    borderBottom: "1px solid rgba(0,0,0,0.25)",
    boxShadow: "inset 0 -1px 0 rgba(255,255,255,0.25), 0 2px 6px rgba(0,0,0,0.25)"
  },

  labelSpacer: {
    width: "330px",
    background: "linear-gradient(180deg, #353a42 0%, #252a30 100%)",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "inset 0 -1px 0 rgba(255,255,255,0.04)"
  },

  timelineScroll: {
    flex: 1,
    overflowX: "auto"
  },

  /* ===============================
     GRID / BODY
     =============================== */

  grid: {
    position: "relative",
    overflow: "auto",
    height: "calc(100vh - 140px)",
    background: "linear-gradient(180deg, #F6F8FB 0%, #EEF2F7 100%)",
    paddingBottom: "40px"
  }

};

